import {doc, serverTimestamp, setDoc} from "firebase/firestore";
import {db} from "@/lib/firebase";
import {useUserStore} from "@/state/userStore";
import {withTimeout} from "@/utils/withTimeout";

const ONBOARDING_COMPLETE_TIMEOUT_MS = 8000;

export async function markOnboardingComplete(userId?: string | null): Promise<void> {
  if (userId) {
    try {
      await withTimeout(
        setDoc(
          doc(db, "users", userId),
          {
            onboardingCompleted: true,
            onboardingCompletedAt: serverTimestamp(),
            postOnboardingTutorialEligible: true,
            postOnboardingTutorialVersion: 1,
            updatedAt: serverTimestamp(),
          },
          {merge: true},
        ),
        ONBOARDING_COMPLETE_TIMEOUT_MS,
        "onboarding completion save",
      );
    } catch (error) {
      console.error("[Onboarding] Error saving onboarding completion", error);
    }
  }

  useUserStore.getState().completeOnboarding();
}
